import Vue from 'vue';
import Vuex from "vuex";
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        peopleMessage: "", //$t('global.个人信息')
        accountUser: "",
        area: "", //$t('global.地区')
        imgIndex: "", //$t('global.上传图片')index
        isLogin: false
    },
    mutations: {
        clear(state) {
            state = Object.assign(state, {
                peopleMessage: "",
                accountUser: "",
                area: "",
                imgIndex: "",
                isLogin: false
            })
        },
        changeLogin(state, isLogin) {
            state.isLogin = isLogin;
        },
        setNewState(state, newState) {
            state = Object.assign(state, newState)
        },
        setImgIndex(state, newImgIndex) {
            state.imgIndex = newImgIndex;
        },
        setArea(state, newArea) {
            state.area = newArea;
        },
        setPeopleMessage(state, newPeopleMessage) {
            state.peopleMessage = newPeopleMessage;
        },
        setAccountUser(state, newAccountUser) {
            state.accountUser = newAccountUser;
        }
    },
    actions: {
        restUser({ commit }) {
            commit('clear');
        },
        changeLogin({ commit }, isLogin) {
            commit('changeLogin', isLogin)
        },
        setNewState({ commit }, newState) {
            commit('setNewState', newState)
        },
        setImgIndex({ commit }, newImgIndex) {
            commit('setImgIndex', newImgIndex)
        },
        setArea({ commit }, newArea) {
            commit('setArea', newArea)
        },
        setPeopleMessage({ commit }, newPeopleMessage) {
            commit('setPeopleMessage', newPeopleMessage)
        },
        setAccountUser({ commit }, newAccountUser) {
            commit('setAccountUser', newAccountUser)
        }
    }
});

export default store;


// WEBPACK FOOTER //
// ./src/store/store.js